/** Do not edit this file, it is automatically generated **/
import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import Icon, { IconProps } from "./Icon";

const IconTextLineComponent: React.FC<PropsWithChildren<IconProps>> & { DataUrl: string; Content: string; } = (props) => {
return (
  <Icon {...props} viewBox="0 0 20 20">
    <g id="Layer_1-2" data-name="Layer 1">
    <g>
        <g>
            <path d="m13.04,15.7h-6.11v-.77c.52,0,.91-.04,1.15-.12.24-.08.4-.25.48-.51.08-.26.12-.66.12-1.19V5h-.8c-.65,0-1.14.08-1.47.23s-.56.42-.7.78c-.14.37-.28.87-.41,1.51h-.89l.2-3.52h10.84l.16,3.52h-.89c-.13-.64-.27-1.15-.42-1.51-.15-.37-.38-.63-.7-.78s-.81-.23-1.48-.23h-.78v8.12c0,.53.04.93.12,1.19.08.26.24.43.48.51s.61.12,1.11.12v.77Z" style={{ strokeWidth: 0 }} />
            <rect x="1.78" y="1.78" width="16.43" height="16.43" rx="5" ry="5" style={{ fill: "none", stroke: "#000", strokeMiterlimit: "10" }} />
        </g>
        <rect width="20" height="20" style={{ fill: "none", strokeWidth: 0 }} />
    </g>
</g>
  </Icon>
);
};

IconTextLineComponent.DataUrl = "data:image/svg+xml;charset=utf-8;base64,PHN2ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+CiAgPGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj4KICAgIDxnPgogICAgICA8Zz4KICAgICAgICA8cGF0aCBkPSJtMTMuMDQsMTUuN2gtNi4xMXYtLjc3Yy41MiwwLC45MS0uMDQsMS4xNS0uMTIuMjQtLjA4LjQtLjI1LjQ4LS41MS4wOC0uMjYuMTItLjY2LjEyLTEuMTlWNWgtLjhjLS42NSwwLTEuMTQuMDgtMS40Ny4yM3MtLjU2LjQyLS43Ljc4Yy0uMTQuMzctLjI4Ljg3LS40MSwxLjUxaC0uODlsLjItMy41MmgxMC44NGwuMTYsMy41MmgtLjg5Yy0uMTMtLjY0LS4yNy0xLjE1LS40Mi0xLjUxLS4xNS0uMzctLjM4LS42My0uNy0uNzhzLS44MS0uMjMtMS40OC0uMjNoLS43OHY4LjEyYzAsLjUzLjA0LjkzLjEyLDEuMTkuMDguMjYuMjQuNDMuNDguNTFzLjYxLjEyLDEuMTEuMTJ2Ljc3WiIgc3R5bGU9InN0cm9rZS13aWR0aDogMHB4Ii8+CiAgICAgICAgPHJlY3QgeD0iMS43OCIgeT0iMS43OCIgd2lkdGg9IjE2LjQzIiBoZWlnaHQ9IjE2LjQzIiByeD0iNSIgcnk9IjUiIHN0eWxlPSJmaWxsOiBub25lOyBzdHJva2U6ICMwMDA7IHN0cm9rZS1taXRlcmxpbWl0OiAxMCIvPgogICAgICA8L2c+CiAgICAgIDxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgc3R5bGU9ImZpbGw6IG5vbmU7IHN0cm9rZS13aWR0aDogMHB4Ii8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4=";
IconTextLineComponent.Content = `<svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
  <g id="Layer_1-2" data-name="Layer 1">
    <g>
      <g>
        <path d="m13.04,15.7h-6.11v-.77c.52,0,.91-.04,1.15-.12.24-.08.4-.25.48-.51.08-.26.12-.66.12-1.19V5h-.8c-.65,0-1.14.08-1.47.23s-.56.42-.7.78c-.14.37-.28.87-.41,1.51h-.89l.2-3.52h10.84l.16,3.52h-.89c-.13-.64-.27-1.15-.42-1.51-.15-.37-.38-.63-.7-.78s-.81-.23-1.48-.23h-.78v8.12c0,.53.04.93.12,1.19.08.26.24.43.48.51s.61.12,1.11.12v.77Z" style="stroke-width: 0px"/>
        <rect x="1.78" y="1.78" width="16.43" height="16.43" rx="5" ry="5" style="fill: none; stroke: #000; stroke-miterlimit: 10"/>
      </g>
      <rect width="20" height="20" style="fill: none; stroke-width: 0px"/>
    </g>
  </g>
</svg>`;

const IconTextLine = styled(IconTextLineComponent)``;

export default IconTextLine;
